<template>
  <article :id="review.id" class="flex flex-col items-start pb-4">
    <div v-if="review.assetId" class="mb-4">
      <image-component
        :asset-id="review.assetId"
        :alt-text="getAltText"
        transformation="pad"
        css-class="lazyload"
        :breakpoint-map="breakpointConfig"
        :qaid="`media-review-image-${review.id}`"
      />
    </div>
    <pdl-heading v-if="mediaReviewHeading" :qaid="`media-review-heading-${review.id}`" :size="headingSize" class="mb-1">
      {{ mediaReviewHeading }}
    </pdl-heading>
    <p v-if="review.body" :qaid="`media-review-body-${review.id}`" class="mb-1">{{ review.body }}</p>
    <pdl-link
      v-if="hasLink"
      standalone
      icon="chevron_right"
      icon-right
      :href="linkUrl"
      v-bind="dynamicAttrs"
      :qaid="`media-review-link-${review.id}`"
    >
      {{ review.link.linkName }}
    </pdl-link>
  </article>
</template>

<script>
import ImageComponent from '@/components/ImageComponent.vue';
import {PdlLink} from '@pedal/pdl-link';
import {mapState, mapGetters} from 'vuex';
import {PdlHeading} from '@pedal/pdl-section-header';
import {ViewSize} from '@/constants/view-breakpoints';
import {createAltText} from '@/utils/image/image-helpers';

export default {
  components: {ImageComponent, PdlLink, PdlHeading},
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      breakpointConfig: {
        xsWidth: 800,
        smWidth: 800,
        mdWidth: 800,
        mlWidth: 800,
        lgWidth: 800,
        xlWidth: 800,
        xxlWidth: 800,
      },
    };
  },
  computed: {
    ...mapState('backend', ['encodedContextPath']),
    ...mapGetters('viewSize', ['viewBreakpointIs']),

    headingSize() {
      return this.viewBreakpointIs(ViewSize.SMALL) ? 'lg' : 'md';
    },

    hasLink() {
      return !!this.review?.link?.url;
    },

    linkUrl() {
      if (this.review?.link?.url?.includes('//')) {
        return this.review?.link?.url;
      }
      return `${this.encodedContextPath}${this.review?.link?.url}`;
    },

    mediaReviewHeading() {
      if (this.review.title) {
        return this.review?.title;
      }
      return this.review?.displayName;
    },

    booleanConversions() {
      return {
        target: this.review?.link?.target.toLowerCase() === 'newwindow',
      };
    },

    dynamicAttrs() {
      return {
        ...(this.booleanConversions.target && {target: '_blank', rel: 'noopener'}),
      };
    },

    getAltText() {
      return createAltText(this.review?.assetId, 'Product Media Review');
    },
  },
};
</script>
